import { createSelector } from 'reselect';
import BigNumber from 'bignumber.js';
import { productPositionAssetsSelector } from 'apex-web/lib/redux/selectors/productPositionSelectors';
import { instrumentSelectorInstrumentsWithLevel1 } from 'apex-web/lib/redux/selectors/instrumentPositionSelectors';

export const getProductByIdSelector = createSelector(
  [
    productPositionAssetsSelector,
    instrumentSelectorInstrumentsWithLevel1,
    (state, productId) => productId
  ],
  (products, instruments, productId) => {
    const currentProduct = products.find(item => item.ProductId === productId);
    const currentInstrument = instruments.find(
      instrument => instrument.Product1 === currentProduct.ProductId
    );
    const amountBN = new BigNumber(currentProduct.rawAmount);
    const notionalBN = new BigNumber(currentInstrument?.LastTradedPx || 1);
    const notionalValue = amountBN.times(notionalBN);
    return {
      ...currentProduct,
      NotionalValue: notionalValue
    };
  }
);

export const selectBalancesWithPrices = createSelector(
  productPositionAssetsSelector,
  instrumentSelectorInstrumentsWithLevel1,
  (balances, instruments) => {
    const balancesWithNotionalValue = balances.map(item => {
      const currentInstrument = instruments.find(
        instrument => instrument.Product1 === item.ProductId
      );
      const amountBN = new BigNumber(item.rawAmount);
      const notionalBN = new BigNumber(currentInstrument?.LastTradedPx || 1);
      const notionalValue = amountBN.times(notionalBN);

      return {
        ...item,
        NotionalValue: notionalValue
      };
    });
    return balancesWithNotionalValue;
  }
);

export const fundedPositionsSelector = createSelector(
  selectBalancesWithPrices,
  positions => {
    // productPositionsSelector replaces Amount 0 with '-'
    return positions.filter(position => position.Amount !== '-');
  }
);
